import React, {
  Component,
  PropTypes
} from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {fetchCipGroupsAction, fetchCipGroupManagersAction} from '../actions/';
import CipGroupsPage from '../components/CipGroups/CipGroupsPage';

class CipGroupsContainer extends Component {

   constructor(props) {
    super(props);
    this.state = {
      filter : {
          includeChildData : true,
          includeInactive : true,
      }
    }
  }


  render() {
    const {actions} = this.props;
    const {cipGroupContainer} = this.props;  
    const {cipGroupManagers}  = this.props;  
    const { authInfo } = this.props;
    const { IsAdmin } = authInfo;

    return <CipGroupsPage authInfo = {authInfo} IsAdmin={IsAdmin} actions={actions} cipGroupManagers={cipGroupManagers} cipGroupContainer={cipGroupContainer} loadCipGroups={this.handleLoadCipGroups.bind(this)}/>;
  }

  handleLoadCipGroups(filter){
    const {actions} = this.props;
    actions.fetchCipGroupsAction(Object.assign({}, filter, this.state.filter));
  }

  componentDidMount() {
    const {actions} = this.props;
    actions.fetchCipGroupsAction(this.state.filter);
    actions.fetchCipGroupManagersAction();
  }

}

CipGroupsContainer.propTypes = {
  actions: PropTypes.shape({})
};

function mapStateToProps(state) {
  const props = {
    cipGroupContainer : state.cipGroups, 
    cipGroupManagers : state.cipGroupManagers,
    authInfo : state.authInfo
  };
  return props;
}

function mapDispatchToProps(dispatch) {
  const actions = {fetchCipGroupsAction, fetchCipGroupManagersAction};
  const actionMap = { actions: bindActionCreators(actions, dispatch) };
  return actionMap;
}

export default connect(mapStateToProps, mapDispatchToProps)(CipGroupsContainer);



// WEBPACK FOOTER //
// ./containers/CipGroupsContainer.js